import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var XpBar = function (_a) {
    var xp = _a.xp, level = _a.level, nextLevel = _a.nextLevel;
    var xpForNextLevel = Long.ZERO;
    var progress = Long.fromInt(100);
    if (nextLevel != undefined) {
        xpForNextLevel = Long.fromInt(nextLevel.requiredXp - level.requiredXp);
        progress = xp
            .subtract(Long.fromValue(level.requiredXp))
            .multiply(100)
            .divide(xpForNextLevel);
    }
    var iconTextComponent = (React.createElement(NumberFormat, { amount: level ? level.level : 1, className: IdStyles.TextBoldSecondaryOutline }));
    return (React.createElement("div", { className: "hud-exp" },
        React.createElement(IconWithProgress, { progressPercent: progress.toNumber(), fillClassName: IdStyles.HudStat + "-fill", backgroundClassName: IdStyles.HudStat + "-background-medium " + IdStyles.HudStat + "-background", iconTextComponent: iconTextComponent, icon: IdIcon.XpIcn, iconStyle: IdStyles.IconLarge },
            React.createElement("div", { className: "" + IdStyles.TextButtonHeading },
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: xp })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/XpBar.tsx
// module id = 885
// module chunks = 3